/* Bellia — logika buy boxu: galeria, wybór zestawu, wybór koloru/rozmiaru per sztuka, dodanie do koszyka. */
(function () {
  'use strict';

  var box = document.querySelector('[data-bl-buybox]');
  if (!box) return;

  var variants = [];
  var opts = { colors: [], sizes: [], labels: { color: 'Kolor', size: 'Rozmiar', piece: 'Sztuka' } };
  try {
    variants = JSON.parse(box.querySelector('[data-bl-variants]').textContent);
    opts = JSON.parse(box.querySelector('[data-bl-options]').textContent);
  } catch (e) {
    return;
  }

  /* ---------------------------------------------------------------- galeria */
  var galMain = box.querySelector('[data-bl-gal-main]');
  var thumbs = [].slice.call(box.querySelectorAll('.bl-gal-thumb'));

  var strip = box.querySelector('[data-bl-gal-thumbs]');
  var arrows = [].slice.call(box.querySelectorAll('[data-bl-strip]'));
  var current = 0;
  // cel przewijania wywolanego strzalka albo miniatura — w tym czasie posrednie
  // pozycje galerii nie moga cofac "current" (kolejne klikniecie liczylo od zlego slajdu)
  var celSlajdu = -1, blokadaDo = 0;

  function markThumb(i) {
    current = i;
    thumbs.forEach(function (t) { t.classList.toggle('is-active', Number(t.dataset.i) === i); });
    // pasek miniatur podaza za aktywnym zdjeciem (bez przewijania calej strony)
    var akt = thumbs[i];
    if (strip && akt) {
      var cel = akt.offsetLeft - strip.offsetLeft - (strip.clientWidth - akt.offsetWidth) / 2;
      try { strip.scrollTo({ left: cel, behavior: 'smooth' }); } catch (e) { strip.scrollLeft = cel; }
    }
    // strzalki przelaczaja zdjecia — wylacz je na pierwszym i ostatnim
    arrows.forEach(function (btn) {
      var kier = Number(btn.dataset.blStrip);
      btn.disabled = kier < 0 ? i <= 0 : i >= thumbs.length - 1;
    });
  }

  function goToSlide(i, smooth) {
    if (!galMain) return;
    var slide = galMain.children[i];
    if (!slide) return;
    celSlajdu = i;
    blokadaDo = Date.now() + 900;
    var left = slide.offsetLeft - galMain.offsetLeft;
    try {
      galMain.scrollTo({ left: left, behavior: smooth === false ? 'auto' : 'smooth' });
    } catch (e) {
      galMain.scrollLeft = left;
    }
    // zabezpieczenie: gdy płynne przewijanie nie zadziała, ustaw pozycję wprost
    setTimeout(function () {
      if (Math.abs(galMain.scrollLeft - left) > 4) galMain.scrollLeft = left;
    }, 350);
    markThumb(i);
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { goToSlide(Number(t.dataset.i)); });
  });

  // strzałki przełączają główne zdjęcie (telefon i komputer), a pasek miniatur
  // podąża za aktywną miniaturą w markThumb() — właściciel 2026-10-22
  arrows.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var kier = Number(btn.dataset.blStrip);
      var cel = Math.max(0, Math.min(thumbs.length - 1, current + kier));
      if (cel !== current) goToSlide(cel);
    });
  });
  markThumb(0);

  if (galMain) {
    var scrollTimer;
    galMain.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var w = galMain.clientWidth || 1;
        var n = Math.round(galMain.scrollLeft / w);
        if (Date.now() < blokadaDo && n !== celSlajdu) return;   // jeszcze jedzie do celu
        celSlajdu = -1;
        if (n !== current) markThumb(n);
      }, 90);
    }, { passive: true });
  }

  function slideForColor(color) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].c === color) return variants[i].i;
    }
    return -1;
  }

  /* ------------------------------------------------------- selektory sztuk */
  function sizeAvailable(color, size) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].c === color && variants[i].s === size) return variants[i].a;
    }
    return false;
  }

  function findVariant(color, size) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].c === color && variants[i].s === size) return variants[i].id;
    }
    return null;
  }

  // rozmiar wybrany w kalkulatorze z okna tabeli rozmiarow (zdarzenie bl:size-pick);
  // listy rozmiarow budowane pozniej (np. po zmianie zestawu) startuja od niego
  var wybranyRozmiar = '';

  function maOpcje(select, value) {
    return [].some.call(select.options, function (o) { return o.value === value; });
  }

  function buildSizeOptions(select, color) {
    var current = select.value || wybranyRozmiar;
    select.innerHTML = '';
    var ph = document.createElement('option');
    ph.value = '';
    ph.textContent = opts.labels.size;
    select.appendChild(ph);
    opts.sizes.forEach(function (s) {
      var o = document.createElement('option');
      o.value = s;
      o.textContent = sizeAvailable(color, s) ? s : s + ' — brak';
      select.appendChild(o);
    });
    if (current && maOpcje(select, current)) select.value = current;
  }

  function imageForColor(color) {
    return (opts.images && opts.images[color]) || '';
  }

  function buildPicker(bundle) {
    var picker = bundle.querySelector('[data-bl-picker]');
    if (!picker || picker.dataset.ready === '1') return;
    var qty = Number(bundle.dataset.qty) || 1;
    var html =
      '<div class="bl-picker-head">' +
        '<span></span><span>' + opts.labels.size +
        // link do tabeli tuz nad listami — tam, gdzie klientka wybiera rozmiar
        (document.querySelector('[data-bl-sizes-modal]') ?
          ' · <button type="button" class="bl-picker-size" data-bl-size-open>tabela rozmiarów</button>' : '') +
        '</span><span>' + opts.labels.color + '</span>' +
      '</div>';
    for (var n = 1; n <= qty; n++) {
      html +=
        '<div class="bl-picker-row" data-bl-row>' +
          '<img class="bl-picker-thumb" data-bl-thumb src="' + imageForColor(opts.colors[0]) + '" alt="' +
            opts.labels.piece + ' ' + n + '" width="42" height="48" decoding="async">' +
          '<select data-bl-size aria-label="' + opts.labels.size + ' — ' + opts.labels.piece.toLowerCase() + ' ' + n + '"></select>' +
          '<select data-bl-color aria-label="' + opts.labels.color + ' — ' + opts.labels.piece.toLowerCase() + ' ' + n + '">' +
            opts.colors.map(function (c) { return '<option value="' + c + '">' + c + '</option>'; }).join('') +
          '</select>' +
        '</div>';
    }
    picker.innerHTML = html;
    picker.dataset.ready = '1';

    [].slice.call(picker.querySelectorAll('[data-bl-row]')).forEach(function (row) {
      var colorSel = row.querySelector('[data-bl-color]');
      var sizeSel = row.querySelector('[data-bl-size]');
      var thumb = row.querySelector('[data-bl-thumb]');
      buildSizeOptions(sizeSel, colorSel.value);
      colorSel.addEventListener('change', function () {
        buildSizeOptions(sizeSel, colorSel.value);
        var src = imageForColor(colorSel.value);
        if (src && thumb) thumb.src = src;
        var i = slideForColor(colorSel.value);
        if (i >= 0) goToSlide(i);
      });
    });
  }

  /* -------------------------------------------------------- wybór zestawu */
  var bundles = [].slice.call(box.querySelectorAll('[data-bl-bundle]'));

  function select(bundle) {
    bundles.forEach(function (b) {
      var on = b === bundle;
      b.classList.toggle('is-selected', on);
      var input = b.querySelector('input[type="radio"]');
      if (input) input.checked = on;
    });
    buildPicker(bundle);
  }

  bundles.forEach(function (b) {
    b.addEventListener('click', function (e) {
      if (e.target.closest('[data-bl-picker]')) return;
      select(b);
    });
    b.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(b); }
    });
  });

  var initial = bundles.filter(function (b) { return b.classList.contains('is-selected'); })[0] || bundles[0];
  if (initial) select(initial);

  /* ------------------------- rozmiar z kalkulatora -> listy w koszyku */
  // Kalkulator w oknie tabeli rozmiarow wysyla bl:size-pick z poleconym rozmiarem.
  // Ustawiamy go we wszystkich sztukach (w zestawie 2+1 to trzy listy), zeby
  // klientka nie przepisywala wyniku recznie — kazde przepisanie to szansa na pomylke.
  document.addEventListener('bl:size-pick', function (e) {
    var rozmiar = e.detail && e.detail.size;
    if (!rozmiar) return;
    wybranyRozmiar = rozmiar;
    [].slice.call(box.querySelectorAll('[data-bl-size]')).forEach(function (sel) {
      if (maOpcje(sel, rozmiar) && sel.value !== rozmiar) {
        sel.value = rozmiar;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    clearError();
    var wybrany = bundles.filter(function (b) { return b.classList.contains('is-selected'); })[0];
    var picker = wybrany && wybrany.querySelector('[data-bl-picker]');
    // chwile pozniej, zeby okno zdazylo sie zamknac i odblokowac przewijanie strony
    if (picker) setTimeout(function () { picker.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 80);
  });

  /* ------------------------------------------- okno z tabelą rozmiarów */
  (function () {
    var openers = [].slice.call(document.querySelectorAll('[data-bl-size-open]'));
    if (!openers.length) return;
    var modal = document.querySelector('[data-bl-sizes-modal]');
    var lastFocus = null;

    function close() {
      if (!modal) return;
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }

    function open() {
      if (!modal) return false;
      lastFocus = document.activeElement;
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('.bl-modal-close');
      if (closeBtn) closeBtn.focus();
      return true;
    }

    // delegacja: dziala tez dla linkow dobudowanych pozniej (naglowek listy rozmiarow, slajd galerii)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bl-size-open]');
      if (!btn) return;
      e.preventDefault();
      if (open()) return;
      // brak okna (sekcja w trybie zwykłym) — przewiń do tabeli
      var target = document.querySelector(btn.dataset.fallback || '#bl-rozmiary');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-bl-modal-close]')) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hasAttribute('hidden')) close();
      });
    }
  })();

  /* ------------------------------------------------------------- licznik */
  var timer = box.querySelector('[data-bl-timer]');
  if (timer) {
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tryb = timer.getAttribute('data-bl-mode') || 'midnight';

    // tryb sesyjny: termin zapisany na czas wizyty, zeby zegar nie skakal
    // przy przejsciu miedzy podstronami, ale ruszal od nowa przy nowym wejsciu
    var koniecSesji = null;
    if (tryb === 'session') {
      var czesci = (timer.getAttribute('data-bl-start') || '07:47').split(':');
      var sekund = (parseInt(czesci[0], 10) || 0) * 60 + (parseInt(czesci[1], 10) || 0);
      try {
        var zapis = sessionStorage.getItem('bl-timer-end');
        koniecSesji = zapis ? parseInt(zapis, 10) : null;
        if (!koniecSesji || koniecSesji < Date.now()) {
          koniecSesji = Date.now() + sekund * 1000;
          sessionStorage.setItem('bl-timer-end', String(koniecSesji));
        }
      } catch (e) {
        koniecSesji = Date.now() + sekund * 1000;   // tryb prywatny — licznik per odslona
      }
    }

    var tick = function () {
      var left;
      if (tryb === 'session') {
        left = Math.max(0, Math.round((koniecSesji - Date.now()) / 1000));
      } else {
        // ile polnocy do przodu — 1 = dzis, 2 = jutro (ustawienie sekcji)
        var dni = parseInt(timer.getAttribute('data-bl-days'), 10) || 1;
        var end = new Date();
        end.setHours(24 * dni, 0, 0, 0);
        left = Math.max(0, Math.floor((end.getTime() - Date.now()) / 1000));
      }
      var h = timer.querySelector('[data-bl-h]');
      var mEl = timer.querySelector('[data-bl-m]');
      if (mEl) {
        if (h) {
          h.textContent = pad(Math.floor(left / 3600));
          mEl.textContent = pad(Math.floor(left % 3600 / 60));
        } else {
          mEl.textContent = pad(Math.floor(left / 60));   // bez kafelka godzin — minuty licza calosc
        }
        timer.querySelector('[data-bl-s]').textContent = pad(left % 60);
      } else {
        timer.textContent = pad(Math.floor(left / 3600)) + ':' + pad(Math.floor(left % 3600 / 60)) + ':' + pad(left % 60);
      }
    };
    tick();
    setInterval(tick, 1000);
  }

  /* --------------------------------------------------- dodanie do koszyka */
  var atc = box.querySelector('[data-bl-atc]');
  var errEl = box.querySelector('[data-bl-err]');

  function showError(msg) {
    if (!errEl) return;
    errEl.textContent = msg;
    errEl.classList.add('is-on');
  }
  function clearError() {
    if (errEl) errEl.classList.remove('is-on');
  }

  if (atc) {
    atc.addEventListener('click', function () {
      clearError();
      var bundle = bundles.filter(function (b) { return b.classList.contains('is-selected'); })[0];
      if (!bundle) return;

      var rows = [].slice.call(bundle.querySelectorAll('[data-bl-row]'));
      var picks = [];
      for (var i = 0; i < rows.length; i++) {
        var color = rows[i].querySelector('[data-bl-color]').value;
        var size = rows[i].querySelector('[data-bl-size]').value;
        if (!size) {
          showError('Wybierz rozmiar dla sztuki ' + (i + 1) + '.');
          rows[i].querySelector('[data-bl-size]').focus();
          return;
        }
        var id = findVariant(color, size);
        if (!id) {
          showError('Ta kombinacja jest niedostępna: ' + color + ' / ' + size + '.');
          return;
        }
        picks.push({ id: id, color: color, size: size });
      }

      var bundleVariant = Number(bundle.dataset.bundleVariant || 0);
      var items;

      if (bundleVariant) {
        var props = {};
        picks.forEach(function (p, n) {
          props[opts.labels.piece + ' ' + (n + 1)] = p.color + ' / ' + p.size;
        });
        items = [{ id: bundleVariant, quantity: 1, properties: props }];
      } else {
        var byId = {};
        picks.forEach(function (p) { byId[p.id] = (byId[p.id] || 0) + 1; });
        items = Object.keys(byId).map(function (id) {
          return { id: Number(id), quantity: byId[id] };
        });
      }

      atc.disabled = true;
      var label = atc.textContent;
      atc.textContent = 'Dodaję…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) {
            showError(res.data.description || res.data.message || 'Nie udało się dodać do koszyka.');
            return;
          }
          // Strona oferty z retargetingu: zestaw ma wlasny kod rabatowy (np. 2+2
          // za 149 zl). Nakladamy go na koszyk, zeby klientka od razu widziala
          // cene z reklamy. Na glownej stronie data-discount jest puste.
          var kod = bundle.dataset.discount;
          // koszyk pokazuje wtedy jeden wiersz „Zestaw 1 + 1” zamiast rozbitych cen par
          try {
            var nazwa = bundle.querySelector('.bl-bundle-label');
            if (kod && nazwa) {
              sessionStorage.setItem('blZestaw', JSON.stringify({ code: kod, label: nazwa.textContent.trim(), qty: picks.length }));
            }
          } catch (e) {}
          if (!kod) {
            document.dispatchEvent(new CustomEvent('bellia:cart:open'));
            return;
          }
          // /cart/update.js podmienia wszystkie kody, wiec zachowujemy darmowy Paczkomat z okienka zapisu
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .catch(function () { return {}; })
            .then(function (cart) {
              var kody = [kod];
              (cart.discount_codes || []).forEach(function (d) {
                if (/^(BLPACZ|PACZ)-/i.test(d.code) && kody.indexOf(d.code) === -1) kody.push(d.code);
              });
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ discount: kody.join(',') })
              });
            })
            .catch(function () { /* koszyk i tak sie otworzy */ })
            .then(function () {
              document.dispatchEvent(new CustomEvent('bellia:cart:open'));
            });
        })
        .catch(function () {
          showError('Brak połączenia ze sklepem. Spróbuj ponownie.');
        })
        .then(function () {
          atc.disabled = false;
          atc.textContent = label;
        });
    });
  }
})();
